// HistoryItem.js
import React, {Fragment, useEffect, useRef, useState} from 'react';
import PixelationOverlay from "./PixelationIverlay";
import Svg from "../../design/routes/common/components/Svg";

export default function HistoryItem({ item, onGenerate, onEditItem, onToggle, onDelete, onAddMoodboard, onRegenerate }) {
  const [expanded, setExpanded] = useState(item.status === 'processing');
  const [isImageExpanded, setIsImageExpanded] = useState(false);
  const [isResultImageExpanded, setIsResultImageExpanded] = useState(false);
  const [elapsedTime, setElapsedTime] = useState(null);
  const itemRef = useRef();
  const isActive = item.status === 'pending' || item.status === 'processing';

  const updateElapsed = () => {
    const created = new Date(item.created_at).getTime();
    const now = item.completed_at ? new Date(item.completed_at).getTime() : Date.now();
    const seconds = Math.floor((now - created) / 1000);
    setElapsedTime(seconds);
  };

  useEffect(() => {
    let interval;

    if (isActive) {
      updateElapsed();
      interval = setInterval(updateElapsed, 1500);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [item.created_at, item.completed_at, item.status]);

  const renderDuration = () => {
    if (isActive && elapsedTime != null) {
      return `${elapsedTime}s`;
    } else if (item.completed_at != null) {
      return `${elapsedTime}s`;
    } else {
      return '...';
    }
  };

  const toggleExpand = () => {
    setExpanded(prev => !prev);
  };

  const toggleImageSize = () => {
    setIsImageExpanded((prev) => !prev);
  };

  const toggleResultImageSize = () => {
    setIsResultImageExpanded((prev) => !prev);
  };

  const itemCompleted = item.status === 'completed';

  const setExpandedAndScroll = (toggle) => {
    setExpanded(toggle);
    const node = itemRef.current;
    const onTransitionEnd = (event) => {
      if (event.propertyName === "width") {
        node.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        node.removeEventListener("transitionend", onTransitionEnd);
      }
    };

    node.addEventListener("transitionend", onTransitionEnd);
  };

  const handleAddMoodboard = () => {
    setExpanded(false);
    onAddMoodboard(item);
  };

  const handleRegenerate = () => {
    setExpanded(false);
    onRegenerate(item);
  };

  const handleEdit = () => {
    setExpanded(false);
    onEditItem(item);
  };

  const handleDownloadClick = (image) => {
    const a = document.createElement('a');
    a.href = image.url.original;
    a.target = '_blank';
    a.download = image.url.original.split('/').pop();
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const renderDownloadButton = (image) => {
    return (
      <button className='download-button' alt='Download' onClick={(e) => {handleDownloadClick(image)}}>
        <Svg icon="download-icon" className="download-icon" />
        <span>Download</span>
      </button>
    )
  };

  const renderAddToMoodboardButton = (image) => {
    return (
      <button className='add-to-moodboard-button' alt='Add to moodboard' onClick={(e) => {handleAddMoodboard()}}>
        <Svg icon="add-icon" className="add-to-moodboard-button-icon" />
        <span>To Design</span>
      </button>
    )
  };

  const renderRegenerateButton = (image) => {
    return (
      <button className='regenerate-button' alt='Regenerate image' onClick={(e) => {handleRegenerate()}}>
        <Svg icon="regenerate-icon" className="regenerate-icon" />
        <span>Regenerate</span>
      </button>
    )
  };

  const renderEditButton = (image) => {
    return (
      <button className='regenerate-button' alt='Regenerate image' onClick={(e) => {handleEdit()}}>
        <Svg icon="icon-edit-button" className="regenerate-icon" />
        <span>Edit</span>
      </button>
    )
  };

  return (
    <div ref={itemRef} className={`history-item ${expanded ? '-expanded' : ''} ${item.deleteInProgress ? '-delete-in-progress' : ''}`}>
      {!expanded && (
        <div className="tile show-delete-btn-on-mouse-over">
          {item.result_image && (
            <img
              src={item.result_image.url.thumbnail}
              className="generated-image -thumbnail"
              onClick={(e) => { setExpandedAndScroll(true)}}
            />
          )}
          {!item.result_image && item.image && (
            <Fragment>
              <img
                src={item.image.url.thumbnail}
                className="generated-image -thumbnail"
                // onClick={(e) => { setExpanded(true) }}
              />
              {(item.status === 'processing' || item.status === 'pending') && (
                <PixelationOverlay src={item.image.url.thumbnail} status={item.status} />
              )}
            </Fragment>
          )}
          <span className={`tile-status ${item.status}`}>{item.status}</span>
          <div className="delete-btn" onClick={(e)=>onDelete(item)}></div>
        </div>
      )}
      {expanded && (
        <div className="history-body">
          {item.result_image && !isImageExpanded && (
            <div className={`image-wrapper ${expanded ? '-expanded-image' : ''}`}>
              <img
                  src={expanded ? item.result_image.url.hero : item.result_image.url.thumbnail}
                  alt="Generated image"
                  className={`generated-image ${expanded ? '-expanded-image' : '-thumbnail'}`}
                  onClick={toggleExpand}
              />

              <div className="image-actions">
                {item.moodboard && item.moodboard.id && renderAddToMoodboardButton(item.result_image)}
                {/*{renderRegenerateButton(item.result_image)}*/}
                {renderEditButton(item.result_image)}
                {renderDownloadButton(item.result_image)}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/components/moodboard_ai_requests/HistoryItem.js